module.exports = require("core-js/library/fn/promise");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/promise.js
// module id = 110
// module chunks = 0 1